/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */

import { BaseModel, Expand, Model, Type } from '../../common';


export interface ForumCategoryRequest {

    id?: number;

    name?: string;

    color?: string;

    text_color?: string;

    slug?: string;

    topic_count?: string;

    post_count?: string;

    position?: string;

    description?: string;

    description_text?: string;

    topic_url?: string;

    read_restricted?: boolean;

    permission?: string;

    parent_category_id?: string;

    notification_level?: string;

    can_edit?: boolean;

    topic_template?: string;

    has_children?: boolean;

    sort_order?: string;

    sort_ascending?: string;

    show_subcategory_list?: string;

    num_featured_topics?: string;

    default_view?: string;

    subcategory_list_style?: string;

    default_top_period?: string;

    minimum_required_tags?: string;

    navigate_to_first_post_after_read?: string;

    topics_day?: string;

    topics_week?: string;

    topics_month?: string;

    topics_year?: string;

    topics_all_time?: string;

    description_excerpt?: string;

    uploaded_logo?: string;

    uploaded_background?: string;

}

@Model('ForumCategory')
export class ApiForumCategory extends BaseModel implements ForumCategoryRequest {

    
    
    id: number;

    
    
    name: string;

    
    
    color: string;

    
    
    text_color: string;

    
    
    slug: string;

    
    
    topic_count: string;

    
    
    post_count: string;

    
    
    position: string;

    
    
    description: string;

    
    
    description_text: string;

    
    
    topic_url: string;

    
    
    read_restricted: boolean;

    
    
    permission: string;

    
    
    parent_category_id: string;

    
    
    notification_level: string;

    
    
    can_edit: boolean;

    
    
    topic_template: string;

    
    
    has_children: boolean;

    
    
    sort_order: string;

    
    
    sort_ascending: string;

    
    
    show_subcategory_list: string;

    
    
    num_featured_topics: string;

    
    
    default_view: string;

    
    
    subcategory_list_style: string;

    
    
    default_top_period: string;

    
    
    minimum_required_tags: string;

    
    
    navigate_to_first_post_after_read: string;

    
    
    topics_day: string;

    
    
    topics_week: string;

    
    
    topics_month: string;

    
    
    topics_year: string;

    
    
    topics_all_time: string;

    
    
    description_excerpt: string;

    
    
    uploaded_logo: string;

    
    
    uploaded_background: string;

}
